function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.12,
  width: 64,
  height: 64,
  rx: 32,
  fill: "#F03B3B"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.68,
  d: "M44.862 34.82A8.445 8.445 0 1032.92 22.878L20.126 35.67 32.07 47.614 44.862 34.82z",
  fill: "#F56565"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.255 34.82a8.445 8.445 0 1111.943-11.943L43.991 35.67 32.048 47.614 19.255 34.82z",
  fill: "#F54E4E"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IG9wYWNpdHk9IjAuMTIiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjMyIiBmaWxsPSIjRjAzQjNCIi8+CjxwYXRoIG9wYWNpdHk9IjAuNjgiIGQ9Ik00NC44NjI1IDM0LjgyMDlDNDguMTYwNyAzMS41MjI4IDQ4LjE2MDcgMjYuMTc1NSA0NC44NjI1IDIyLjg3NzNDNDEuNTY0NCAxOS41NzkyIDM2LjIxNzEgMTkuNTc5MiAzMi45MTg5IDIyLjg3NzNMMjAuMTI2IDM1LjY3MDNMMzIuMDY5NiA0Ny42MTM5TDQ0Ljg2MjUgMzQuODIwOVoiIGZpbGw9IiNGNTY1NjUiLz4KPHBhdGggZD0iTTE5LjI1NDggMzQuODIwOUMxNS45NTY2IDMxLjUyMjggMTUuOTU2NiAyNi4xNzU1IDE5LjI1NDggMjIuODc3M0MyMi41NTI5IDE5LjU3OTIgMjcuOTAwMyAxOS41NzkyIDMxLjE5ODQgMjIuODc3M0w0My45OTEzIDM1LjY3MDNMMzIuMDQ3NyA0Ny42MTM5TDE5LjI1NDggMzQuODIwOVoiIGZpbGw9IiNGNTRFNEUiLz4KPC9zdmc+Cg==";
export { SvgHeart as ReactComponent };